import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { EstablishmentRequestService } from './establishmentrequest.service';
import { global } from '../../../shared/global';
import { EstablishmentDetail } from '../../Models/establishmentdetail.model';
declare var $: any;

@Component({
  selector: 'app-establishmentrequest',
  templateUrl: './establishmentrequest.component.html',
  styleUrls: ['./establishmentrequest.component.css']
})
export class EstablishmentrequestComponent implements OnInit {
  @ViewChild('establishmentRequest') establishmentRequest: NgForm;
  dropDownData: any;
  mediums: any;
  allocatereq: any;
  boards: any;
  sections: any;
  courses:any;
  data: EstablishmentDetail;
  submitted: boolean;
  base64file: any;
  fileextension: any;
  responseData: any;
  doc: any;
  establishmentDetailList: any;
  searchtext: any;
  isDesc: boolean;
  column: string;
  p: any;
  pageLimit = global.pageLimit;
  totalEstablish:any;
  totalPages = 10;

  constructor(private service: EstablishmentRequestService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/collegelogin']);
      return;
    }
    document.getElementById('YearID').addEventListener('change', () => {
      this.getEstablishmentDetailList(this.p);
});
    this.data = new EstablishmentDetail();
    $("#searchtext").val("");
    this.fillMedium();
    this.fillBoard();
    this.fillSection();
    this.fillStandard(0);
    this.getEstablishmentDetailList(this.p);
    
    var dtToday = new Date();
    var month: string = (dtToday.getMonth() + 1).toString();
    var day: string = (dtToday.getDate()).toString();
    var year: string = (dtToday.getFullYear()).toString();
    if (parseInt(month) < 10)
      month = '0' + month.toString();
    if (parseInt(day) < 10)
      day = '0' + day.toString();
    var maxDate = year + '-' + month + '-' + day;
    $('#EstablishmentDate').attr('max', maxDate);

  }
  fillBoard() {
    const data = {
      HashCode: localStorage.getItem("HashCode")
    };
    this.service.fillBoard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.boards = this.dropDownData.dropdownlist;
        this.data.BoardID = 0;
      });
  }
  fillMedium() {
    const data = {
      HashCode: localStorage.getItem("HashCode")
    };
    this.service.fillMedium(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.mediums = this.dropDownData.dropdownlist;
        this.data.MediumID = 0;
      });
  }
  fillSection() {
    const data = {
      HashCode: localStorage.getItem("HashCode")
    };
    this.service.fillSection(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.sections = this.dropDownData.dropdownlist;
        this.data.SectionID = 0;
      });
  }
  fillStandard(section) {
    const data = {
      HashCode: localStorage.getItem("HashCode"),
      SectionID:section
    };
    this.service.fillStandard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.courses = this.dropDownData.dropdownlist;
        this.data.CourseID = 0;
      });
  }
  getEstablishmentDetailList(page) {
    this.p = page;
    var search = "";
    if($("#searchtext").val() != undefined || $("#searchtext").val() != null || $("#searchtext").val() != ""){
      search = $("#searchtext").val();
    }
    const data = {
      HashCode: localStorage.getItem("HashCode"),
      YearID : localStorage.getItem("YearID"),
      SearchText : search,
      OffSet : (this.p - 1) * this.pageLimit,
      pagelimit : this.pageLimit
    
    };
    this.spinner.show();
    this.service.getEstablishmentDetailList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.establishmentDetailList = [];
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/collegelogin']);
          return
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.establishmentDetailList = this.responseData.establishmentDetailListRequests;
          this.totalEstablish = this.responseData.totalCount;
          setTimeout(() => {
            for (var i = 0; i < this.establishmentDetailList.length; i++) {
              // $('#ExpenseDate' + i).val(this.establishmentDetailList[i]["EstablishmentDate"]);
              if (this.establishmentDetailList[i]["Extension"] == ".pdf") {
                document.getElementById("preview_" + i).setAttribute("src", "assets/images/pdfimage.jpg");
              }
            }
          }, 1000);
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/collegelogin']);
      });
  }
  uploadImage(event) {
    if (event.target.files.length > 0) {
      this.doc = event.target.files[0];
      if (Math.round(this.doc.size / 1024) > 1000) {
        this.toastr.error("File size can't be greater then 1 MB");
        return;
      }
      this.fileextension = this.doc.name.split('.');
      if (this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "jpg" && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "png"
        && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "jpeg" && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "pdf") {
        this.toastr.error("You can upload only jpg, jpeg, png or pdf file");
        return;
      }

      const [file] = event.target.files;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        //this.base64file = reader.result as string;
        var base64file = reader.result as string;
        this.base64file = base64file;
        this.fileextension = "." + this.fileextension[this.fileextension.length - 1].toString().toLowerCase();
      }
    } else {
      this.base64file = null;
      this.fileextension = null;
    }
  }
  onSubmit() {
    this.submitted = true;
    if (this.data.BoardID == 0 || this.data.BoardID == undefined
      || this.data.MediumID == 0 || this.data.MediumID == undefined || this.data.SectionID == undefined || this.data.SectionID == 0) {
      return;
    }
    if (this.base64file == null || this.fileextension == null) {
      return;
    }
    if (this.establishmentRequest.valid) {
      this.spinner.show();
      this.data.Base64File = this.base64file;
      this.data.FileExtension = this.fileextension;
      this.data.YearID = Number(localStorage.getItem("YearID"));
      this.service.saveEstablishmentDetail(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            localStorage.clear();
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/collegelogin']);
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.getEstablishmentDetailList(this.p);
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }
  deleteEstablishmentDetail(HashCode,filePath) {
    var a = confirm("Are you sure you want to delete ?");
    if (a) {
      const data = {
        HashCode: HashCode,
        FilePath: filePath
      };
      this.spinner.show();
      this.service.deleteEstablishmentDetail(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            localStorage.clear();
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/collegelogin']);
            return
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.getEstablishmentDetailList(this.p);
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }
  resetForm() {
    this.submitted = false;
    this.base64file = null;
    this.fileextension = null;
    $("#customFile").val('');
    this.data.BoardID = 0;
    this.data.MediumID = 0;
    this.data.SectionID = 0;
    this.data.CourseID=0;
    this.data.EstablishmentDate = null;
    this.data.Base64File = null;
    this.data.FileExtension = null;
    this.data.HashCode = null;
    this.data.ID =null;
  }
  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.establishmentDetailList.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }
  setpage() {
    this.p = 1;
  }
}
